window.addEventListener("DOMContentLoaded", () => {
  let isInitial = true;
  const swiperContainer = document.querySelector(
    ".product-page-influencer-swiper"
  );

  const swiper = new Swiper(swiperContainer, {
    width: 280,
    spaceBetween: 16,
  });

  const modalVideoSwiper = new Swiper(".influencers-modal-handle-swiper", {
    slidesPerView: "auto",
    spaceBetween: 8,
  });

  const videoButtons = document.querySelectorAll(".influencer-watch-button");

  videoButtons.forEach((button) => {
    button.addEventListener("click", handleVideoButtonClick);
  });

  const closeModalBtn = document.getElementById("closeModalBtn");
  const modalOverlay = document.querySelector(
    ".modal-overlay[data-role='influencers-modal']"
  );
  closeModalBtn.addEventListener("click", closeModal);

  const modalIframe = modalOverlay.querySelector("iframe");
  modalIframe.addEventListener("load", () => {
    if (!isInitial) {
      openModal();
    }
  });

  // Close modal when clicking outside the modal card
  modalOverlay.addEventListener("mouseup", (event) => {
    if (event.target === modalOverlay) {
      closeModal();
    }
  });

  const influencerHandles = document.querySelectorAll(
    ".influencers-modal-handle"
  );

  influencerHandles.forEach((item) =>
    item.addEventListener("click", handleInfluencerNameClick)
  );

  // FUNCTIONS
  function handleVideoButtonClick(e) {
    isInitial = false;
    const idx = e.target.dataset.influencerIndex;
    modalVideoSwiper.slideTo(idx);
    handleModalContentChange(e.target, true);
  }

  function handleModalContentChange(button, shouldHighlight) {
    const link = button.dataset.link;
    const type = button.dataset.type; // "embed" | "video"
    const influencerIndex = button.dataset.influencerIndex;
    const iframeContainer = modalOverlay.querySelector(
      ".influencers-embed-container"
    );
    const video = modalOverlay.querySelector(".influencers-modal-video");

    if (shouldHighlight) {
      highlightHandle(influencerIndex);
    }
    if (type === "embed") {
      video.pause();
      modalIframe.src = link;
      iframeContainer.classList.add("visible");
      video.classList.remove("visible");
    } else if (type === "video") {
      iframeContainer.classList.remove("visible");
      video.classList.add("visible");
      video.src = link;
      openModal();
    } else {
      throw new Error(`unhandled type:'${type}'`);
    }
  }

  function highlightHandle(index) {
    const highlightedHandle = document.querySelector(
      ".influencers-modal-handle.highlighted"
    );
    highlightedHandle?.classList.remove("highlighted");
    const handle = document.querySelector(
      `.influencers-modal-handle[data-influencer-index='${index}']`
    );
    if (!handle) return;
    handle.classList.add("highlighted");
  }

  function handleInfluencerNameClick(e) {
    const button = e.target;
    const type = button.dataset.type; // "embed" | "video"
    const index = button.dataset.influencerIndex;
    const watchButton = document.querySelector(
      `.influencer-watch-button[data-influencer-index='${index}']`
    );
    handleModalContentChange(watchButton, type === "video");
    modalIframe.addEventListener("load", watchIframe);
    function watchIframe() {
      highlightHandle(index);
      modalIframe.removeEventListener("load", watchIframe);
    }
  }

  function openModal() {
    modalOverlay.style.display = "flex";
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    modalOverlay.style.display = "none";
    document.body.style.overflow = "";
    const iframeContainer = modalOverlay.querySelector(
      ".influencers-embed-container"
    );
    iframeContainer.classList.remove("visible");

    const video = modalOverlay.querySelector(".influencers-modal-video");
    video.classList.remove("visible");
  }
});
